import { Outlet } from "react-router";
import { TextFiltersDictionaryItemsContextProvider } from "./common/context/TextFiltersDictionaryItemsContextProvider";

const WorkbookRunnerContainer = () => {
  return (
    <TextFiltersDictionaryItemsContextProvider>
      <Outlet />
    </TextFiltersDictionaryItemsContextProvider>
  );
};

export default WorkbookRunnerContainer;
